module.exports = __webpack_public_path__ + "img/small.a347d537.jpg";